/** @format */

export const GET_ABOUTME_REQUEST = "GET_ABOUTME_REQUEST";
export const GET_ABOUTME_SUCCESS = "GET_ABOUTME_SUCCESS";
export const GET_ABOUTME_FAIL = "GET_ABOUTME_FAIL";

export const GET_WEB_PROJECTS_REQUEST = "GET_PROJECTS_REQUEST";
export const GET_WEB_PROJECTS_SUCCESS = "GET_WEB_PROJECTS_SUCCESS";
export const GET_WEB_PROJECTS_FAIL = "GET_WEB_PROJECTS_FAIL";

export const GET_CERTIFICATE_REQUEST = "GET_CERTIFICATE_REQUEST";
export const GET_CERTIFICATE_SUCCESS = "GET_CERTIFICATE_SUCCESS";
export const GET_CERTIFICATE_FAIL = "GET_CERTIFICATE_FAIL";

export const GET_MOBILE_PROJECTS_REQUEST = "GET_MOBILE_PROJECTS_REQUEST";
export const GET_MOBILE_PROJECTS_SUCCESS = "GET_MOBILE_PROJECTS_SUCCESS";
export const GET_MOBILE_PROJECTS_FAIL = "GET_PROJECTS_FAIL";

export const GET_API_PROJECTS_REQUEST = "GET_API_PROJECTS_REQUEST";
export const GET_API_PROJECTS_SUCCESS = "GET_API_PROJECTS_SUCCESS";
export const GET_API_PROJECTS_FAIL = "GET_API_PROJECTS_FAIL";

export const GET_UI_PROJECTS_REQUEST = "GET_UI_PROJECTS_REQUEST";
export const GET_UI_PROJECTS_SUCCESS = "GET_UI_PROJECTS_SUCCESS";
export const GET_UI_PROJECTS_FAIL = "GET_UI_PROJECTS_FAIL";

export const GET_OTHER_PROJECTS_REQUEST = "GET_OTHER_PROJECTS_REQUEST";
export const GET_OTHER_PROJECTS_SUCCESS = "GET_OTHER_PROJECTS_SUCCESS";
export const GET_OTHER_PROJECTS_FAIL = "GET_OTHER_PROJECTS_FAIL";

export const POST_COMMENT_REQUEST = "POST_COMMENT_REQUEST";
export const POST_COMMENT_SUCCESS = "POST_COMMENT_SUCCESS";
export const POST_COMMENT_FAIL = "POST_COMMENT_FAIL";

export const GET_SOCIALLINKS_REQUEST = "GET_SOCIALLINKS_REQUEST";
export const GET_SOCIALLINKS_SUCCESS = "GET_SOCIALLINKS_SUCCESS";
export const GET_SOCIALLINKS_FAIL = "GET_SOCIALLINKS_FAIL";

export const GET_TimeStamp_REQUEST = "GET_TimeStamp_REQUEST";
export const GET_TimeStamp_SUCCESS = "GET_TimeStamp_SUCCESS";
export const GET_TimeStamp_FAIL = "GET_TimeStamp_FAIL";
